import { FC } from "react";
import classNames from "classnames";
import { RowSeat } from "src/Modules/Flights/constants/JourneyDetails";
import RowItem from "../RowItem/RowItem";

export const MIN_SEAT_COLUMN_WIDTH = "clamp(3rem, 9vw, 4rem)";

const RowSeating: FC<{
  colMap: Map<number, string>;
  row: RowSeat;
  onClick: any;
  reservedSeats: string[];
  isMobile?: boolean;
}> = ({
  colMap,
  row,
  onClick,
  reservedSeats,
  isMobile,
}) => {
  const colsRendered = Array.from(colMap.entries());
  const gridFullCols = colsRendered.length;
  return (
    <div
      className={classNames("grid w-full items-center gap-2")}
      style={{
        gridTemplateColumns: `repeat(${gridFullCols}, minmax(${isMobile ? MIN_SEAT_COLUMN_WIDTH : "0"},1fr))`,
      }}
    >
      {colsRendered.map((col,index) => {
        return <RowItem row={row} col={col} onClick={onClick} reservedSeats={reservedSeats} key={`item-${index}`}/>;
      })}
    </div>
  );
};

export default RowSeating;
